// 移除未使用的引入，避免 no-unused-vars 报错

export default {
  methods: {
    async login() {
      // 从loginForm或组件data中获取手机号和验证码
      const phoneNum = this.loginForm.CellPhoneNo || this.CellPhoneNo || this.loginForm.LoginID;
      const smsCode = this.loginForm.Captcha || this.Captcha;

      if (!phoneNum || !smsCode) {
        throw new Error('请填写手机号与验证码');
      }

      // 使用新的查询参数格式
      const loginUrl = `/api/login?type=20&phone_num=${encodeURIComponent(phoneNum)}&sms_code=${encodeURIComponent(smsCode)}`;
      const result = await this.$store.dispatch('postData', {
        url: loginUrl,
        data: {},
        need_sign: false
      });
      console.log('登录接口返回的result:', result);
      // 新接口返回格式：{ token, expire }
      if (result && result.token) {
        // 保存token
        localStorage.setItem('token', result.token);
        localStorage.setItem('tokenExpire', result.expire);

        // 保存用户基本信息（手机号）
        const person = { CellPhoneNo: phoneNum };
        this.$store.commit('updatePerson', person);

        // 直接跳转到首页
        this.$store.commit('updateToHome', true);
        this.$router.replace('home');
      } else {
        throw new Error('登录失败，请重试');
      }
    },
    async goShare(url) {
      this.go(url);
      // try {
      //   this.$loading();
      //   const result = await this.$store.dispatch('postData', {
      //     url: '/user/getStatus',
      //     data: { Extra: { PersonSysNo: this.$store.state.person.PersonSysNo } }
      //   });
      //   if (result === 1) {
      //     this.$toast('请等待工作人员为您培训指导后进行转发');
      //   } else if (result === 2) {
      //     this.$toast('您未通过考核，期待未来能与您合作');
      //   } else if (result === 3) {
      //     this.$loadingClose();
      //     this.$dialog.confirm({
      //       title: '提示',
      //       message: '您已通过考核，为了更快捷为您结算收入，请实名认证及签约',
      //       confirmButtonText: '去认证'
      //     }).then(() => {
      //       this.go('auth-info');
      //     });
      //   } else if (result === 4) {
      //     this.$loadingClose();
      //     this.$dialog.confirm({
      //       title: '提示',
      //       message: '为了更快捷为您结算收入，请签约',
      //       confirmButtonText: '去签约'
      //     }).then(async () => {
      //       const contracts = await this.$store.dispatch('postData', {
      //         url: '/recruit/GetContractList',
      //         data: { Extra: { PersonSysNo: this.$store.state.person.PersonSysNo } }
      //       });
      //       const signlist = contracts.List.filter(v => v.ContractStatus === 10);
      //       const list = contracts.List.filter(v => v.ContractStatus === 0);
      //       if (!list.length && !signlist.length) {
      //         return this.$error(`协议未生成，请稍后再试`);
      //       }
      //       if (list.length) {
      //         let res = await this.$store.dispatch('postData', {
      //           url: '/recruit/SendContractStart',
      //           data: {
      //             Body: {
      //               PersonSysNo: this.$store.state.person.PersonSysNo,
      //               ContractSysNo: list[0].ContractSysNo,
      //               returnUrl: `https://signfinish.dasheng78.cn/ssq?cCode=${list[0].ContractSysNo}`
      //             }
      //           }
      //         });
      //         location.href = res.longUrl + '&opentype=inwk';
      //       }
      //     });
      //   } else {
      //     this.go(url);
      //   }
      // } catch (e) {
      //   this.$error(e.message);
      // }
    },
    async checkShare(fun) {
      // 直接执行分享，不做状态拦截
      fun();
      // this.$loadingClose();
      // try {
      //   this.$loading();
      //   const result = await this.$store.dispatch('postData', {
      //     url: '/user/getStatus',
      //     data: { Extra: { PersonSysNo: this.$store.state.person.PersonSysNo } }
      //   });
      //   if (result === 1) {
      //     this.$toast('请等待工作人员为您培训指导后进行转发');
      //   } else if (result === 2) {
      //     this.$toast('您未通过考核，期待未来能与您合作');
      //   } else if (result === 3) {
      //     this.$loadingClose();
      //     this.$dialog.confirm({
      //       title: '提示',
      //       message: '您已通过考核，为了更快捷为您结算收入，请实名认证及签约',
      //       confirmButtonText: '去认证'
      //     }).then(() => {
      //       this.$loadingClose();
      //       this.go('auth-info');
      //     });
      //   } else if (result === 4) {
      //     this.$loadingClose();
      //     this.$dialog.confirm({
      //       title: '提示',
      //       message: '为了更快捷为您结算收入，请签约',
      //       confirmButtonText: '去签约'
      //     }).then(async () => {
      //       const contracts = await this.$store.dispatch('postData', {
      //         url: '/recruit/GetContractList',
      //         data: { Extra: { PersonSysNo: this.$store.state.person.PersonSysNo } }
      //       });
      //       const signlist = contracts.List.filter(v => v.ContractStatus === 10);
      //       const list = contracts.List.filter(v => v.ContractStatus === 0);
      //       if (!list.length && !signlist.length) {
      //         return this.$error(`协议未生成，请稍后再试`);
      //       }
      //       if (list.length) {
      //         let res = await this.$store.dispatch('postData', {
      //           url: '/recruit/SendContractStart',
      //           data: {
      //             Body: {
      //               PersonSysNo: this.$store.state.person.PersonSysNo,
      //               ContractSysNo: list[0].ContractSysNo,
      //               returnUrl: `https://signfinish.dasheng78.cn/ssq?cCode=${list[0].ContractSysNo}`
      //             }
      //           }
      //         });
      //         this.$loadingClose();
      //         location.href = res.longUrl + '&opentype=inwk';
      //       }
      //     });
      //   } else {
      //     this.$loadingClose();
      //     fun();
      //   }
      // } catch (e) {
      //   this.$error(e.message);
      // }
    }
  }
};
